import deMessages from './de-de.json';

const DeLang = {
  messages: {
    ...deMessages,
  },
  locale: 'de-DE',
};
export default DeLang;
